// Filtre modelinin tipi
export type ExpenseNoteFilterModel = {
    orderNo: string;
    shipmentNo: string;
    compassNo: string;
    startDate: string | null;
    endDate: string | null;
    status: string | null;
    setOrderNo: (val: string) => void;
    setShipmentNo: (val: string) => void;
    setCompassNo: (val: string) => void;
    setStartDate: (val: string | null) => void;
    setEndDate: (val: string | null) => void;
    setStatus: (val: string | null) => void;
  };
  
  // Başlangıç boş değerleri
  export const initialEmpty = {
    orderNo: '',
    shipmentNo: '',
    compassNo: '',
    startDate: null as string | null,
    endDate: null as string | null,
    status: null as string | null,
  };
  
  // FilterModel oluşturucu fonksiyon
  export const createFilterModel = (
    orderNo: string,
    shipmentNo: string,
    compassNo: string,
    startDate: string | null,
    endDate: string | null,
    status: string | null,
    setOrderNo: (val: string) => void,
    setShipmentNo: (val: string) => void,
    setCompassNo: (val: string) => void,
    setStartDate: (val: string | null) => void,
    setEndDate: (val: string | null) => void,
    setStatus: (val: string | null) => void
  ): ExpenseNoteFilterModel => {
    return {
      orderNo,
      shipmentNo,
      compassNo,
      startDate,
      endDate,
      status,
      setOrderNo,
      setShipmentNo,
      setCompassNo,
      setStartDate,
      setEndDate,
      setStatus
    };
  };
  export{};